import styled from "styled-components";
import {Button} from "../../controls";

export const NewCampaignButton = styled(Button)`

`;